import { render, staticRenderFns } from "./AgreementPopup.vue?vue&type=template&id=79ac8da8&scoped=true"
import script from "./AgreementPopup.vue?vue&type=script&lang=js"
export * from "./AgreementPopup.vue?vue&type=script&lang=js"
import style0 from "./AgreementPopup.vue?vue&type=style&index=0&id=79ac8da8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79ac8da8",
  null
  
)

export default component.exports